var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-menu-vue"},[_c('Menu',{ref:"menu",attrs:{"datas":_vm.datas,"className":"h-menu-white"},on:{"click":_vm.trigger}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }